module.exports = __webpack_public_path__ + "media/images/icons/icon-close-light-0dec99f807da98bd772b92592725d666.svg";